theme.footerSection = (function(){
  function footer(){
    // Constants
    const MOBILE_BREAKPOINT = 768;
    
    // State
    let eventListenersAttached = false;
    let clickHandlers = []; // Store references for proper cleanup
    
    // Check if we're on mobile
    const isMobile = () => window.outerWidth < MOBILE_BREAKPOINT;
    
    // Handle accordion toggle click
    const handleToggleClick = function(toggle) {
      const footerWidget = toggle.closest('.footer__widget');
      if (!footerWidget) return;
      
      const footerWidgetInner = footerWidget.querySelector('.footer__widget_inner');
      if (!footerWidgetInner) return;
      
      if (footerWidget.classList.contains('active')) {
        // Close
        footerWidget.classList.remove('active');
        slideUp(footerWidgetInner);
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        // Open
        footerWidget.classList.add('active');
        slideDown(footerWidgetInner);
        toggle.setAttribute('aria-expanded', 'true');
        
        // Close siblings (accordion behavior)
        getSiblings(footerWidget.parentElement).forEach(function(sibling) {
          const siblingWidget = sibling.querySelector('.footer__widget');
          if (!siblingWidget) return;
          
          const siblingInner = siblingWidget.querySelector('.footer__widget_inner');
          const siblingToggle = siblingWidget.querySelector('.footer__widget_toggle');
          
          siblingWidget.classList.remove('active');
          if (siblingInner) {
            slideUp(siblingInner);
          }
          if (siblingToggle) {
            siblingToggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    };
    
    // Add event listeners (mobile only)
    const addEventListeners = function() {
      if (!isMobile() || eventListenersAttached) {
        return;
      }
      
      const toggles = document.querySelectorAll(".footer__widget_toggle");
      toggles.forEach(function(toggle) {
        const handler = function() {
          handleToggleClick(toggle);
        };
        toggle.addEventListener('click', handler);
        clickHandlers.push({ toggle, handler });
      });
      
      eventListenersAttached = true;
    };
    
    // Remove event listeners
    const removeEventListeners = function() {
      if (!eventListenersAttached) {
        return;
      }
      
      clickHandlers.forEach(function({ toggle, handler }) {
        toggle.removeEventListener('click', handler);
      });
      
      clickHandlers = [];
      eventListenersAttached = false;
    };
    
    // Reset desktop state
    const resetDesktopState = function() {
      document.querySelectorAll('.footer__widget').forEach(function(widget) {
        widget.classList.remove('active');
        
        const inner = widget.querySelector('.footer__widget_inner');
        if (inner) {
          inner.style.display = '';
        }
        
        const toggle = widget.querySelector('.footer__widget_toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    };
    
    // Handle resize with debouncing
    const handleResize = debounce(function() {
      if (isMobile()) {
        // Mobile: ensure listeners are attached
        addEventListeners();
      } else {
        // Desktop: remove listeners and reset state
        removeEventListeners();
        resetDesktopState();
      }
    }, 250);
    
    // Initial setup
    if (isMobile()) {
      addEventListeners();
    } else {
      resetDesktopState();
    }
    
    // Resize handler
    window.addEventListener('resize', handleResize);
  }
  
  return footer;
})();
